//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            planets: [
                {
                    title: this.$lang.get('dashboard.planets-finished.planets.week1'),
                    videos: [
                        'w1d1',
                        'w1d3',
                        'w1d4'
                    ]
                },
                {
                    title: this.$lang.get('dashboard.planets-finished.planets.week2'),
                    videos: [
                        'w2d1',
                        'w2d2_1',
                        'w2d2_2',
                        'w2d3_1',
                        'w2d3_2',
                        'w2d4'
                    ]
                },
                {
                    title: this.$lang.get('dashboard.planets-finished.planets.week3'),
                    videos: [
                        'w3d1',
                        'w3d2_1',
                        'w3d2_2',
                        'w3d3_1',
                        'w3d3_2',
                        'w3d3_3',
                        'w3d3_4',
                        'w3d4'
                    ]
                },
                {
                    title: this.$lang.get('dashboard.planets-finished.planets.week4'),
                    videos: [
                        'w4d1',
                        'w4d2',
                        'w4d3',
                        'w4d4'
                    ]
                }
            ]
        };
    }
};
